//
// Footer.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./SectionRepeat";
import "./FooterPosition";
import "./MediaContainer";

var Footer = createModule("BIRD::Footer", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        footerPosition: 4,
        mediaContainer: [1],
        repeat: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default Footer;
